import {
  getSearchedReceivableTransaction,
  createReceivable,
} from '@/services/receivables';
import router from '@/router/router';
import { Message } from 'element-ui';
import * as types from '../mutation-types';

const state = {
  receivableTransactions: [],
  isReceivableLoading: true,
  receivableTransactionsPagination: {},
  receivableTransactionsPaginationQuery: 'page=1&perPage=25',
  searchQuery: '',
  selectedFilters: [],
  selectedDueDates: [],
  orderBy: 'o=-status',
  isCreatingNewReceivable: false,
  newReceivable: {},
};

const getters = {
  getReceivableTransactions: state => state.receivableTransactions,
  getReceivableTransactionsPaginationQuery: state =>
    state.receivableTransactionsPaginationQuery,
  getReceivablesLoading: state => state.isReceivableLoading,
  getReceivableTransactionsPagination: state =>
    state.receivableTransactionsPagination,
  getReceivablesSearchQuery: state => state.searchQuery,
  getNewReceivableModalVisibility: state => state.isCreatingNewReceivable,
  getReceivablesSelectedDueDates: state => state.selectedDueDates,
  getReceivablesSelectedFilters: state => state.selectedFilters,
  getCreatedReceivable: state => state.newReceivable,
};

const mutations = {
  [types.SET_RECEIVABLES_LOADING](state) {
    state.isReceivableLoading = true;
  },
  [types.SET_RECEIVABLE_TRANSACTIONS](state, receivableTransactions) {
    state.receivableTransactions = receivableTransactions;
    state.isReceivableLoading = false;
  },
  [types.SET_RECEIVABLE_SEARCH_QUERY](state, query) {
    state.searchQuery = query;
  },
  [types.SET_RECEIVABLES_FILTERS](state, filters) {
    state.selectedFilters = filters;
  },
  [types.SET_RECEIVABLES_DUE_DATES](state, filters) {
    const d = new Date();
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = d.getFullYear();
    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    const todayDateFormated = [year, month, day].join('-');
    const isPastDue = filters[0] !== todayDateFormated;
    if (isPastDue) {
      state.orderBy = 'o=-status';
    }
    state.selectedDueDates = filters;
  },
  [types.SET_CREATING_NEW_RECEIVABLE](state, status) {
    state.isCreatingNewReceivable = status;
  },
  [types.SET_RECEIVABLE_TRANSACTIONS_PAGINATION](state, receivableTransactionsPagination) {
    state.receivableTransactionsPagination.perPage =
    parseInt(receivableTransactionsPagination.perPage);//eslint-disable-line
    state.receivableTransactionsPagination.page = receivableTransactionsPagination.page;
    state.receivableTransactionsPagination.total = receivableTransactionsPagination.total;
    state.receivableTransactionsPaginationQuery = `page=${receivableTransactionsPagination.page}&perPage=${receivableTransactionsPagination.perPage}`;
  },
  [types.SET_RECEIVABLES_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy;
  },
  [types.SET_NEW_RECEIVABLE_CREATED](state, receivable) {
    state.newReceivable = receivable;
  },
};

const actions = {
  getSearchedReceivableTransactionsData({ commit, getters }, changePage) {
    commit(types.SET_RECEIVABLES_LOADING);
    let query = `${getters.getReceivableTransactionsPaginationQuery}`;
    if (state.searchQuery !== '') {
      query += `&q=${state.searchQuery}`;
    }
    if (!changePage) {
      const paginationObj = {};
      if (typeof getters.getReceivableTransactionsPagination.perPage === 'undefined') {
        paginationObj.perPage = '25';
      } else {
        paginationObj.perPage = getters.getReceivableTransactionsPagination.perPage;
      }
      paginationObj.page = 1;
      commit(types.SET_RECEIVABLE_TRANSACTIONS_PAGINATION, paginationObj);
    }
    // verify status
    for (let i = 0; i < state.selectedFilters.length; i += 1) {
      query += `&status=${state.selectedFilters[i]}`;
    }
    // verify date
    if (state.selectedDueDates.length > 0) {
      query += `&due_0=${state.selectedDueDates[0]}`;
      query += `&due_1=${state.selectedDueDates[1]}`;
    }
    // orderBy
    query += `&${state.orderBy}`;

    getSearchedReceivableTransaction(query)
      .then(response => response.data)
      .then((data) => {
        commit(types.SET_RECEIVABLE_TRANSACTIONS, data.results);
        commit(types.SET_RECEIVABLE_TRANSACTIONS_PAGINATION, data.pagination);
      })
      .catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
        } else {
          Message.error('Something went wrong! Try again.');
        }
      });
  },
  updateReceivableTransactionsPagination({ commit }, paginationQuery) {
    return commit(types.SET_RECEIVABLE_TRANSACTIONS_PAGINATION, paginationQuery);
  },
  setReceivablesSearchQuery({ commit }, query) {
    commit(types.SET_RECEIVABLE_SEARCH_QUERY, query);
  },
  setReceivablesSelectedFilters({ commit }, filters) {
    commit(types.SET_RECEIVABLES_FILTERS, filters);
  },
  setReceivablesSelectedDueDates({ commit }, filters) {
    commit(types.SET_RECEIVABLES_DUE_DATES, filters);
  },
  setNewReceivableModalVisibility({ commit }, status) {
    commit(types.SET_CREATING_NEW_RECEIVABLE, status);
  },
  createNewReceivable({ dispatch, commit }, receivable) {
    createReceivable(receivable)
      .then((response) => {
        dispatch('getSearchedReceivableTransactionsData');
        commit(types.SET_NEW_RECEIVABLE_CREATED, response);
        router.push({
          name: 'rt-detail',
          params: { id: response.data.id },
        });
      })
      .catch(() => {
        Message.error('Something went wrong! Try again.');
      });
  },
  updateReceivableOrderBy({ commit }, orderByQuery) {
    return commit(types.SET_RECEIVABLES_ORDER_BY, orderByQuery);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/receivables.js